module.exports = __webpack_public_path__ + "static/media/109-sort.43641c66.svg";